import { render } from "./NightmodeSetting.vue?vue&type=template&id=5b4a4d82"
import script from "./NightmodeSetting.vue?vue&type=script&lang=js"
export * from "./NightmodeSetting.vue?vue&type=script&lang=js"

import "./NightmodeSetting.vue?vue&type=style&index=0&id=5b4a4d82&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__